module.exports = __webpack_public_path__ + "images/manifestum/pictoOCK.0c341e41.svg";